import * as types from '../mutation-types'
import api from '@/api/files'

// initial state
const state = {
    images: [],
    loaded: false,
    imageCategories: [],
    categoriesLoaded: false,
}

const getters = {
    defaultImages: state => state.images,
    imagesLoaded: state => state.loaded,
    imageCategories: state => state.imageCategories,
    imageCategoriesLoaded: state => state.categoriesLoaded,
}

const actions = {
    getImagesCategories({ commit }, params) {
        commit(types.SET_IMAGES_CATEGORIES_LOADED, false );
        api.getCategoriesImages((response) => {
            commit(types.SET_IMAGES_CATEGORIES, response._embedded.SettingGlobal );
            commit(types.SET_IMAGES_CATEGORIES_LOADED, true );
            params.id_category = response._embedded.SettingGlobal[0].idSettingGlobal
            api.getDefaultImages(params, (response) => {
                commit(types.SET_IMAGES, response.files );
                commit(types.SET_IMAGES_LOADED, true );
            })
        })
    },
    getDefaultImagesPerCategory({ commit }, params) {
        commit(types.SET_IMAGES_LOADED, false );
        api.getDefaultImages(params, (response) => {
            commit(types.SET_IMAGES, response.files );
            commit(types.SET_IMAGES_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_IMAGES] (state, images ) {
        state.images = images;
    },
    [types.SET_IMAGES_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_IMAGES_CATEGORIES] (state, categories ) {
        state.imageCategories = categories;
    },
    [types.SET_IMAGES_CATEGORIES_LOADED] (state, status ) {
        state.categoriesLoaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


